import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { AuthProvider, useAuth } from './components/Auth/AuthContext';
import SignIn from './components/Auth/SignIn';
import SignUp from './components/Auth/SignUp';
import Dashboard from './components/Dashboard/Dashboard';
import HomePage from './components/Home/HomePage';
import './App.css';

// Configure Amplify with the Cognito details from our deployed stack
Amplify.configure({
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_hfv7Jm7Ee', // From CloudFormation output
    userPoolWebClientId: '48ka73ok524amja3oddut5hdr', // From CloudFormation output
    mandatorySignIn: true,
    authenticationFlowType: 'USER_SRP_AUTH'
  }
});

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/signin" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  const { checkAuthState } = useAuth();
  
  // Check authentication state when the app loads
  useEffect(() => {
    checkAuthState();
  }, [checkAuthState]);
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dashboard/*" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
